const fetchXML = async (url: string) => {
  const res = await fetch(url)
  const content = await res.text()
  const parser = new DOMParser()
  return parser.parseFromString(content, "text/xml")
}

export { fetchXML }
